document.addEventListener('DOMContentLoaded', () => {
  const countryButtons = document.querySelectorAll('.country-selector__button');

  countryButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const form = button.closest('form');
      const countryCode = button.value;

      if (form && countryCode) {
        const countryInput = form.querySelector('input[name="country_code"]');
        if (countryInput) {
          countryInput.value = countryCode;
        }
        form.submit();
      }
    });
  });
});